import uniqid from 'uniqid';
import { useSelector } from 'react-redux';
import { CruiseCard } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import { getProductsIncluded } from '../../utils/mappers/productsIncluded';
import { standaloneUrlHandler } from '../../utils/url/url';
import { getProductImpression, logProductClick } from '../../utils/logUtils/CruiseListLogUtils';

import { selectLabels, selectSearchInformation, selectVisibleCruises } from '../../redux/selectors/cruiseList';

// The `bindActionCreators` block this used to carry bound every cruise-list action into an
// `actions` prop the component never read; it is gone. The `isInspiration` conditional it
// duplicated from the container now lives in `selectVisibleCruises`.
const CruiseCardList = () => {
  const filteredAndSortedCruises = useSelector(selectVisibleCruises);
  const labels = useSelector(selectLabels) ?? {};
  const searchInformation = useSelector(selectSearchInformation);

  const isGlobetrotter = useIsGlobetrotter();
  const showPricePerPerson = searchInformation?.numberOfAdults === 2 && searchInformation?.numberOfChildren === 0;

  return filteredAndSortedCruises.map((cruisePackage, idx) => {
    const tags = [{ text: cruisePackage.cruise?.categoryText }];
    const firstUsp = labels.cruiseNumberOfNightsText.replace('{numberOfNights}', cruisePackage.cruise?.duration);
    const plusMore =
      cruisePackage.cruise?.itinerary?.filter((stop) => stop.resort !== '')?.length <= 4 ? '' : labels.plusMoreText;
    const itinerarySubTitleText = cruisePackage.cruise?.cruiseItinerarySubTitle
      ? `${cruisePackage.cruise?.cruiseItinerarySubTitle} ${plusMore}`
      : '';
    const flightText = cruisePackage.transport ? labels.flightIncludedText : '';
    const hotelNightsText =
      cruisePackage.numberOfHotelNights > 1
        ? `${cruisePackage.numberOfHotelNights} ${labels.manyHotelNightsText}`
        : labels.oneHotelNightText;
    const uspList = cruisePackage.cruise?.usps || [];
    const promoLabel = cruisePackage.cruise?.promoLabel;

    const cruiseCardContent = {
      bullets: [cruisePackage.cruise?.duration > 0 && firstUsp, ...uspList],
      buttonText: labels?.chooseLabel,
      footerDescription: (
        <>
          {getProductsIncluded(cruisePackage.packageTag, labels)}
          <br />
          {cruisePackage.durAndDep}
        </>
      ),
      image: cruisePackage.cruise?.cruiseListImage,
      ksps: [
        cruisePackage.numberOfHotelNights > 0 ? `${flightText} + ${hotelNightsText}` : flightText,
        cruisePackage.cruise?.mealText,
        cruisePackage.cruise?.addedValue,
      ].filter(Boolean),
      price: cruisePackage?.totalPriceRounded,
      pricePerPerson: showPricePerPerson && cruisePackage.pricePerPax,
      rating: cruisePackage.cruise?.cruiseShipRating,
      ratingPrefix: cruisePackage.cruise?.cruiseShipName,
      subtitle: itinerarySubTitleText,
      tags: isGlobetrotter ? [] : tags.map((tag) => tag.text),
      title: cruisePackage.tripRuleName,
      url: standaloneUrlHandler(`/${cruisePackage.cruise?.cruiseDetailsLink}`),
      promotionLabel: {
        text: promoLabel?.text,
        type: promoLabel?.promotionType,
        urgency: promoLabel?.urgency,
      },
    };
    return (
      <CruiseCard
        bullets={cruiseCardContent.bullets}
        buttonText={cruiseCardContent.buttonText}
        footerDescription={cruiseCardContent.footerDescription}
        image={cruiseCardContent.image}
        key={uniqid('cruise-list-card-')}
        ksps={cruiseCardContent.ksps}
        onClickGallery={() => window.postMessage(`gallery?itemType=cruise&id=${cruisePackage?.cruise?.id}`)}
        imageGalleryCount={cruisePackage?.cruise?.imageGalleryCount}
        onClick={() => logProductClick(getProductImpression(cruisePackage, idx + 1))}
        price={cruiseCardContent.price}
        pricePerPerson={cruiseCardContent.pricePerPerson}
        rating={cruiseCardContent.rating}
        ratingPrefix={cruiseCardContent.ratingPrefix}
        subtitle={cruiseCardContent.subtitle}
        tags={cruiseCardContent.tags}
        title={cruiseCardContent.title}
        url={cruiseCardContent.url}
        promotionLabel={cruiseCardContent.promotionLabel}
      />
    );
  });
};

export default CruiseCardList;
